import { render, staticRenderFns } from "./NormalDeviceDetail.vue?vue&type=template&id=3382fb97&"
import script from "./NormalDeviceDetail.vue?vue&type=script&lang=ts&"
export * from "./NormalDeviceDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports